export default "__VITE_ASSET__c5e0cc86__"